import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateCode',
  pure: true
})
@Injectable()
export class TranslateCodePipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) {}

  transform(value: any = "No message found"): any {
    const trans = this.translate.get(value).toPromise();
    return trans;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/translate.ts